import cn from 'classnames'
import { DragNDropFileUploader, IFileSettings } from 'legacy/lut/library/dragNDrop'
import { useCallback } from 'react'

import { useFormField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'

import { QBR_REPORT_FORM_KEY } from '../../configs'
import { IQBRReportIssueAttachment } from '../../models'

import { AttachmentFiles } from './components/attachmentFiles/AttachmentFiles'
import { prepareAttachments } from './helpers/prepareAttachments'

import styles from './UploadAttachments.module.scss'

interface IUploadAttachments {
  initialValue: IQBRReportIssueAttachment[]
  onValidate?: (value: IQBRReportIssueAttachment[]) => string | Promise<string>
  isDisabled?: boolean
  isVisible?: boolean
  acceptedFormats?: string
}

export const UploadAttachments = ({
  initialValue = [],
  onValidate,
  isVisible,
  isDisabled,
  acceptedFormats,
}: IUploadAttachments) => {
  const field = 'attachments'
  const { handleChange, value, validationMessage } = useFormField<IQBRReportIssueAttachment[]>({
    defaultValue: initialValue,
    field,
    formKey: QBR_REPORT_FORM_KEY,
    onValidate,
    isVisible,
  })
  const isFileListEmpty = value.length === 0

  const handleDeleteFile = useCallback(
    async (id: string) => {
      const newFiles = value.filter((file) => file.id !== id)
      await handleChange(newFiles)
    },
    [value, handleChange]
  )
  const handleMultiLoadFile = useCallback(
    async (filesInfo: IFileSettings[]) => {
      const newAttachments = prepareAttachments(filesInfo)
      await handleChange([...value, ...newAttachments])
    },
    [handleChange, value]
  )

  return (
    <div>
      <div className={styles.validationMessage}>
        <Translation text={validationMessage} span />
      </div>
      <div className={styles.container}>
        <div>
          <DragNDropFileUploader
            disabled={isDisabled}
            required
            changeFileLoader={handleMultiLoadFile}
            urlInputVisibility={false}
            fileListVisibility={false}
            acceptedFormats={acceptedFormats}
            multifiles
          />
        </div>

        <div
          className={cn({
            [styles.isFileListHidden]: isFileListEmpty,
          })}
        >
          <AttachmentFiles files={value} onDelete={handleDeleteFile} isDisabled={isDisabled} />
        </div>
      </div>
    </div>
  )
}
